import { getWxUserPage, getWxUserById, exportWxUser, unbindDistribution } from '@/api/wx'
import { message } from 'ant-design-vue'
import { useExportExcel } from '@/hooks'

export class WxController {
  static async userPage (params: COMMON.API.QueryParams) {
    const { code, data } = await getWxUserPage(params)
    return {
      code,
      data: data.records,
      sum: data.total
    }
  }

  static async getWxUserById (id: string) {
    const { code, data } = await getWxUserById(id)
    if (code === 0) {
      return data
    } else {
      message.error()
    }
  }

  static async exportWxUser () {
    const data = await exportWxUser()
    /* eslist-disabled */
    useExportExcel(data as any, '微信用户')
    console.log('data:', data)
  }

  static async unbindDistribution (id: string) {
    const { code } = await unbindDistribution(id)
    code === 0 ? message.success('解绑成功') : message.error('解绑失败')
  }
}
